module.exports = __webpack_public_path__ + "static/media/protip-slide-2.e6eca7d2.jpg";